module.exports = __webpack_public_path__ + "img/iconTelephama.a3e07a6a.svg";